import ShowAlert from "./show_alert";

const errObject = {
    '403' : {
        'msg': 'Access Denied: User is not authorized to perform this operation.',
        'alertType': 'ERROR!'
    },
    '401' : {
        'msg': 'Access Denied: User is not authorized to perform this operation.',
        'alertType': 'ERROR!'
    },
    '409' : {
        'msg': 'The name already exists, please provide another one.',
        'alertType': 'ERROR!'
    },
    '404' : {
        'msg': 'File does not exist.',
        'alertType': 'ERROR!'
    },
    '412' : {
        'msg': 'Could not assign the attribute(s) having N/A rule.',
        'alertType': 'Warning!'
    },
    '408' : {
        'msg' : 'Server encountered an issue. Please try again.',
        'alertType': 'ERROR!'
    },
    '499' : {
        'msg' : 'API call has been cancelled.',
        'alertType' : 'Information'
    }
}

const errorMsgUtil = (err) => {

    let errMsg, statusCode = (err.response || {}).status || 0;

    //Java service {error:{message:"actual error message"}}
    errMsg = (((err.response || {}).data || {}).error || {}).message;

    //Node service {message: "actual error message"}
    errMsg = errMsg ? errMsg: ((err.response || {}).data || {}).message;

    let stsCode = parseInt(statusCode,10);
    errMsg = errMsg ? errMsg : (errObject[stsCode] ? errObject[stsCode].msg : 'Unable to process the request currently');
    if(stsCode === 403 || stsCode === 401) {
        errMsg = errObject[stsCode].msg;
    }
    ShowAlert({
        variant: errObject[stsCode] ? errObject[stsCode].alertType : 'ERROR!',
        text: errMsg,
        heading: errObject[stsCode] ? `${errObject[stsCode].alertType}` : 'ERROR!'
    });
}

export default errorMsgUtil;